import { createUseStyles } from "react-jss";
import { COLORS } from "./defaults";

export const useSidebarStyles = createUseStyles({
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: "0px",
    right: "-1px",
    zIndex: 1000, // Asegura que el botón esté encima del contenido
  },
  rotatingButton: {
    top: "10px",
    backgroundColor: "transparent",
    color: "white",//COLORS.primary.main,
    border: "none",
    width: "3rem",
    height: "3rem",
    fontSize: "2rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  menuContainer: {
    position: "fixed",
    top: "0",
    right: "0",
    width: "60vw",
    height: "100vh",
    backgroundColor: "#3d3d3df3",//"rgba(43, 42, 43, 0.95)",
    borderTopLeftRadius: "12px",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.)",
    transition: "transform 0.3s ease", 
  },
  menuOption: {
    // padding: "0.1em 0.1em",
    color: "white",
    cursor: "pointer",
    borderBottom: "1px solid #CCC",
    "&:hover": {
      backgroundColor: "#444",
    },
  },
});
